import { Table } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import classes from './styles.module.css';
import { StorageTableRowItem } from '@/containers/pages/commonSettings/tabs/StoragePage/components/Table/components/StorageTableRowItem';
import { IStorageConfiguration } from '@/services/api/storageConfigurationApiArea/types';
import { useMediaQuery } from '@mantine/hooks';

interface Props {
  storages: IStorageConfiguration[];
  onUpdate?(): void;
}

export function StorageTable(props: Props) {
  const { t } = useTranslation();
  const { storages, onUpdate } = props;
  const isMobile = useMediaQuery('(max-width: 576px)');

  return (
    <Table style={{ tableLayout: 'fixed' }}>
      <Table.Thead>
        <Table.Tr>
          <Table.Th className={classes.headerCell} style={{ width: isMobile ? '50%' : '30%' }}>
            {t('storagePage.table.nameHeader')}
          </Table.Th>
          <Table.Th className={classes.headerCell} style={{ width: isMobile ? '30%' : '20%' }}>
            {t('storagePage.table.typeHeader')}
          </Table.Th>
          <Table.Th className={classes.headerCell} style={{ width: isMobile ? '20%' : '10%' }}>
            {t('storagePage.table.activityHeader')}
          </Table.Th>
          <Table.Th className={classes.headerCell} style={{ width: isMobile ? '25%' : '10%' }} />
          <Table.Th className={classes.headerCell} style={{ width: isMobile ? '15%' : '10%' }} />
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {storages.map((element) => (
          <StorageTableRowItem key={element.Id} element={element} onUpdate={onUpdate} />
        ))}
      </Table.Tbody>
    </Table>
  );
}
